import { httpsCallable } from 'firebase/functions'
import React, { useState, useRef, useEffect } from 'react'
import { functions } from '../../firebase/config'
import { deleteOldOrders, getOrdersCount } from '../../api/OrdersAPI';
import { getAllUsersWithCommunityId } from '../../api/UserAPI';
import { Oval } from 'react-loader-spinner';
import QRCodeStyling from 'qr-code-styling';

export default function Errors() {

  const [loading, setLoading] = useState(false);

  const handleSendPush = async () => {};

  async function sendTicketEmail() {}

  async function makeUserAdmin() {}

  const [idToQuery, setidToQuery] = useState('');
  const [usersWithQueryId, setusersWithQueryId] = useState([]);

  async function getAllUsersWithCommunityIdInSubCollection() {
    setLoading(true);
    const res = await getAllUsersWithCommunityId(idToQuery);
    if (res.success) {
      setusersWithQueryId(res.users);
    } else {
      console.error('Error fetching users:', res.error);
    }
    setLoading(false);
  }

  // ─── QR Code Generator ───
  const [qrUrl, setQrUrl] = useState('');
  const [qrLogo, setQrLogo] = useState(null);
  const [qrLogoPreview, setQrLogoPreview] = useState('');
  const qrRef = useRef(null);
  const qrCodeInstance = useRef(null);

  const handleLogoUpload = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => {
      setQrLogo(reader.result);
      setQrLogoPreview(reader.result);
    };
    reader.readAsDataURL(file);
  };

  const generateQR = () => {
    if (!qrUrl) return;

    if (qrCodeInstance.current) {
      qrCodeInstance.current._container?.firstChild?.remove();
    }

    const qrCode = new QRCodeStyling({
      width: 1024,
      height: 1024,
      type: 'canvas',
      data: qrUrl,
      image: qrLogo || undefined,
      dotsOptions: { color: '#000000', type: 'rounded' },
      backgroundOptions: { color: '#ffffff' },
      imageOptions: { crossOrigin: 'anonymous', margin: 10, imageSize: 0.35 },
      cornersDotOptions: { type: 'dot' },
      cornersSquareOptions: { type: 'extra-rounded' },
    });

    qrCodeInstance.current = qrCode;
    if (qrRef.current) {
      qrRef.current.innerHTML = '';
      qrCode.append(qrRef.current);
    }
  };

  const downloadQR = () => {
    if (!qrCodeInstance.current) return;
    qrCodeInstance.current.download({ name: 'qr-code', extension: 'png' });
  };

  return (
    <div>
      {/* ─── QR Code Generator ─── */}
      <div style={{
        background: '#fff', borderRadius: 14, padding: '1.5rem',
        margin: '1rem', boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
        maxWidth: 500
      }}>
        <h3 style={{ margin: '0 0 1rem', fontSize: '1.1rem', fontWeight: 700 }}>QR Code Generator</h3>

        <input
          type="text"
          placeholder="Enter website URL"
          value={qrUrl}
          onChange={(e) => setQrUrl(e.target.value)}
          style={{
            width: '100%', padding: '0.6rem 0.8rem', borderRadius: 8,
            border: '1px solid #ccc', fontSize: '0.9rem', marginBottom: '0.8rem',
            boxSizing: 'border-box'
          }}
        />

        <div style={{ display: 'flex', alignItems: 'center', gap: '0.8rem', marginBottom: '1rem' }}>
          <label style={{
            padding: '0.5rem 1rem', background: '#eee', borderRadius: 8,
            cursor: 'pointer', fontSize: '0.85rem', fontWeight: 600
          }}>
            Upload Logo
            <input type="file" accept="image/*" onChange={handleLogoUpload} style={{ display: 'none' }} />
          </label>
          {qrLogoPreview && (
            <img src={qrLogoPreview} alt="logo" style={{ width: 36, height: 36, borderRadius: 6, objectFit: 'cover' }} />
          )}
        </div>

        <div style={{ display: 'flex', gap: '0.6rem', marginBottom: '1rem' }}>
          <button
            onClick={generateQR}
            disabled={!qrUrl}
            style={{
              padding: '0.6rem 1.2rem', background: '#333', color: '#fff',
              border: 'none', borderRadius: 8, fontWeight: 700, cursor: 'pointer',
              opacity: qrUrl ? 1 : 0.5
            }}
          >
            Generate
          </button>
          <button
            onClick={downloadQR}
            disabled={!qrCodeInstance.current}
            style={{
              padding: '0.6rem 1.2rem', background: '#4a90d9', color: '#fff',
              border: 'none', borderRadius: 8, fontWeight: 700, cursor: 'pointer',
              opacity: qrCodeInstance.current ? 1 : 0.5
            }}
          >
            Download PNG
          </button>
          <button
            onClick={() => qrCodeInstance.current?.download({ name: 'qr-code', extension: 'svg' })}
            disabled={!qrCodeInstance.current}
            style={{
              padding: '0.6rem 1.2rem', background: '#e67e22', color: '#fff',
              border: 'none', borderRadius: 8, fontWeight: 700, cursor: 'pointer',
              opacity: qrCodeInstance.current ? 1 : 0.5
            }}
          >
            Download SVG
          </button>
        </div>

        <div ref={qrRef} style={{ display: 'flex', justifyContent: 'center' }}>
          <div ref={el => { if (el) el.querySelector('canvas')?.style.setProperty('max-width', '100%'); }} />
        </div>
      </div>

      {/* ─── Existing buttons ─── */}
      <div style={{ padding: '1rem' }}>
        <button onClick={() => handleSendPush()}>Send Push Notification</button>
        <button onClick={() => sendTicketEmail()}>Send Email</button>
        <button onClick={() => deleteOldOrders()}>Delete old orders</button>
        <button onClick={() => getOrdersCount()}>Get order Count</button>
        <button onClick={() => makeUserAdmin()}>#make admin</button>
        <button onClick={() => {}}>#</button>
        <br />
        <input className="event-input" value={idToQuery} onChange={(e) => setidToQuery(e.target.value)} />
        <button onClick={() => getAllUsersWithCommunityIdInSubCollection()}>get all users with communityId</button>

        {loading && <Oval visible={true} height="30" width="30" color="#ffffff" ariaLabel="oval-loading" />}

        {usersWithQueryId.length > 0 && !loading && (
          <div>
            <h3>Users in Community {idToQuery}:</h3>
            <ul>
              {usersWithQueryId.map((user) => (
                <li key={user.id}>{user.id + ' - ' + user.name} ({user.email})</li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  )
}